import { render, staticRenderFns } from "./17.vue?vue&type=template&id=233a26bc&scoped=true&"
import script from "./17.vue?vue&type=script&lang=js&"
export * from "./17.vue?vue&type=script&lang=js&"
import style0 from "./17.vue?vue&type=style&index=0&id=233a26bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a26bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('233a26bc')) {
      api.createRecord('233a26bc', component.options)
    } else {
      api.reload('233a26bc', component.options)
    }
    module.hot.accept("./17.vue?vue&type=template&id=233a26bc&scoped=true&", function () {
      api.rerender('233a26bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/17.vue"
export default component.exports